import { useController, useFormContext } from 'react-hook-form';

import { FileInput } from '../../components/FileInput';

export interface RHFFileInputProps {
    name: string;
    dataTestid?: string;
    disabled?: boolean;
    multiple?: boolean;
    defaultValue?: Array<File | { name: string; id?: string; url?: string }>;
    required?: boolean;
    withAccordion?: boolean;
    showIcon?: boolean;
}

export const RHFFileInput = ({
    name,
    dataTestid,
    disabled,
    multiple = true,
    defaultValue = [],
    required = false,
    withAccordion = false,
    showIcon = false,
}: RHFFileInputProps) => {
    const { control, setValue, watch } = useFormContext();
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue,
    });

    const currentValue = watch(name) || defaultValue;

    const handleSetValue = (
        fieldName: string,
        value: Array<File | { name: string; id?: string; url?: string }>
    ): void => {
        setValue(fieldName, value, { shouldValidate: true, shouldDirty: true });
    };

    return (
        <FileInput
            name={field.name}
            value={field.value}
            dataTestid={dataTestid}
            disabled={disabled}
            setValue={handleSetValue}
            defaultValue={currentValue}
            multiple={multiple}
            required={required}
            errorMessage={fieldState.error?.message}
            withAccordion={withAccordion}
            showIcon={showIcon}
        />
    );
};
